/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import Form from 'react-bootstrap/Form'
import {useTranslation} from 'react-i18next'
import {updateLevel, updateSetting} from '../../../api/modules/userlevel'
import axios from 'axios'
import swal from 'sweetalert'
import Pagination from '../component/Pagination'
import {fetchSettingConfig, headers} from '../../../services/fetcher'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {objToParams} from '../../../utils/objToParams'
import {RowFilter} from './RowFilter'
import {
  filterSelector,
  resetFilterSettingConfig,
  setFilterUserLevel,
  setIsFetchData,
} from '../../../redux/slices/filterSlices'
import {SelectPageSize} from '../../../components/SelectPageSize/SelectPageSize'
import {useRowTable} from '../../../hooks/useRowTable'
import * as TableUI from '../../../components/Table/Table'
import {StyledCard} from '../../../components/StyledCard'
import {StyledButtonGroups} from '../../../components/StyledButtonGroups'
import {HakAkses} from '../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'
import i18next from 'i18next'
import {format} from 'date-fns'

type Props = {
  className: string
}

interface ISettingConfig {
  id: number
  created_at: string
  feature: string
  status: boolean
  updated_at: number
}
const SettingConfig: React.FC<Props> = ({className}) => {
  const {t} = useTranslation()
  const {roleId} = useAppSelector(authSelector)
  const {filterSettingConfig} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 4,
    onReloadTable: () => handleResetTable(),
  })

  const [isLoading, setIsLoading] = useState(true)
  const [userData, setUserData] = useState<ISettingConfig[]>([])
  const [numberURL, setNumberURL] = useState([])
  const [addName, setAddName] = useState('')
  const [approval, setApproval] = useState<any>([])
  const [ID, setID] = useState(0)
  const [actived, setActived] = useState(false)
  const [page, setPage] = useState(1)
  const [isError, setIsError] = useState(false)

  const [setting, setSetting] = useState<any>([])

  const handleToggleChange = async (id: number, index: number) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (yes) => {
      if (yes) {
        updateSetting(id, {status: !setting[index].status, lang: i18next.language}).then(() => {
          onFetchSettingConfig()
        })
      }
    })
  }

  const rowNumber = useMemo(() => {
    const per = filterSettingConfig?.per_page ?? 5
    return page * per - per
  }, [filterSettingConfig, page])

  const paginateNumber = async (url: string) => {
    try {
      setIsLoading(true)

      const endpoint = `${url}&${objToParams(filterSettingConfig)}`
      const token = localStorage.getItem('token') as string
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })

      setSetting(res.data.data.data)
      setNumberURL(res.data.data.links)
      setPage(res.data.data.current_page)
    } catch (error) {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  const onFetchSettingConfig = useCallback(() => {
    setIsLoading(true)
    setIsError(false)

    fetchSettingConfig(filterSettingConfig)
      .then((res) => {
        setSetting(res.data.data.data)
        setNumberURL(res.data.data.links)
        setPage(res.data.data.current_page)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setIsLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterSettingConfig, dispatch])

  useEffect(() => {
    const getData = setTimeout(onFetchSettingConfig, 1000)
    return () => clearTimeout(getData)
  }, [onFetchSettingConfig])

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterUserLevel({...filterSettingConfig, per_page: value ?? 5}))
  }

  const handleResetTable = () => {
    dispatch(resetFilterSettingConfig())
  }

  useEffect(() => {
    return () => {
      handleResetTable()
    }
  }, [])

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <SelectPageSize
            initialValue={filterSettingConfig?.per_page ?? 5}
            onChange={(value: any) => handlePageSizeChange(value?.value)}
          />
        }
      />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <tr>
              <th>{t('No')}</th>
              <th>{t('RowFilter.Feature')}</th>
              <th>{t('Status')}</th>
              <th>{t('RowFilter.Date')}</th>
              {hakAkses?.update && <th>{t('order-aksi')}</th>}
            </tr>
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {isLoading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : setting.length === 0 ? (
              <RowEmptyData />
            ) : (
              setting.map((data: any, _index: any) => (
                <tr key={data?.id ?? _index}>
                  <td>{_index + 1 + rowNumber}</td>
                  <td>{data.label}</td>
                  <td>{data.status ? t('active') : t('deactive')}</td>
                  <td>{format(new Date(data.updated_at), 'dd MMMM yyyy, HH:mm:ss')}</td>
                  {hakAkses?.update && (
                    <td>
                      <Form>
                        <Form.Check
                          type='switch'
                          id='custom-switch'
                          checked={data.status}
                          onChange={() => handleToggleChange(data.id, _index)}
                        />
                      </Form>
                    </td>
                  )}
                </tr>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />
    </StyledCard>
  )
}

export {SettingConfig}
